import { render, staticRenderFns } from "./Swatches.vue?vue&type=template&id=d209d250&scoped=true&"
import script from "./Swatches.vue?vue&type=script&lang=js&"
export * from "./Swatches.vue?vue&type=script&lang=js&"
import style0 from "./Swatches.vue?vue&type=style&index=0&id=d209d250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d209d250",
  null
  
)

export default component.exports